import { SvgIcon, SvgIconProps } from "@mui/material";

export function AssignIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31">
      <path
        fill="#62C3EE"
        fillRule="evenodd"
        d="M12.802 17.268v.367c0 1.025-.004 2.05 0 3.075.005.882.478 1.349 1.364 1.355.537.004 1.073.002 1.61 0 .96-.001 1.423-.46 1.425-1.414.002-1.015 0-2.03.001-3.046 0-.103.01-.207.015-.337h.342c1.034 0 2.069.005 3.104 0 .845-.005 1.322-.482 1.331-1.328.006-.566.004-1.132.001-1.698-.004-.909-.463-1.369-1.368-1.37-1.025-.003-2.05-.001-3.075-.002h-.35v-.349c0-1.034.004-2.07-.002-3.104-.005-.87-.477-1.34-1.34-1.344-.555-.003-1.112-.001-1.668 0-.927.002-1.387.456-1.39 1.38-.003 1.025 0 2.05 0 3.075v.343h-.356c-1.034 0-2.069-.004-3.104 0-.868.004-1.33.47-1.335 1.343-.003.586-.006 1.172.001 1.757.01.808.49 1.288 1.303 1.295.937.009 1.874.002 2.81.002h.68M0 15.993v-1.758c.017-.084.044-.167.05-.252.146-2.094.688-4.083 1.715-5.909C4.527 3.161 8.74.487 14.37.14a13.746 13.746 0 0 1 7.663 1.74c4.92 2.752 7.59 6.972 7.938 12.602.168 2.705-.427 5.285-1.735 7.665-2.325 4.232-5.876 6.815-10.625 7.728-.572.11-1.156.16-1.735.237h-1.758c-.075-.016-.15-.043-.226-.048-1.84-.12-3.606-.56-5.257-1.374-4.6-2.267-7.415-5.923-8.4-10.966-.11-.57-.159-1.154-.236-1.731"
      />
    </SvgIcon>
  );
}

export function ViewIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 35">
      <path
        fill="#62C3EE"
        fillRule="evenodd"
        d="M17.978.113C27.283.045 34.952 7.665 35 17.04c.048 9.461-7.633 17.103-17.016 17.07C8.73 34.177 1.052 26.56 1 17.266.948 7.784 8.473.18 17.978.113zm.04 9.45c-1.307-.013-2.574.207-3.781.702-3.031 1.245-5.071 3.508-6.507 6.383-.177.353-.129.682.039 1.022.78 1.583 1.79 3.002 3.113 4.17 3.237 2.858 6.922 3.623 10.961 2.071 3.033-1.164 5.015-3.496 6.437-6.347.161-.323.157-.651-.028-.952-.552-.898-1.046-1.845-1.696-2.668-2.17-2.749-4.958-4.353-8.538-4.382zm-.02 3.779a3.76 3.76 0 0 1 3.775 3.733c.01 2.12-1.656 3.805-3.77 3.812a3.76 3.76 0 0 1-3.774-3.77 3.76 3.76 0 0 1 3.77-3.775z"
      />
    </SvgIcon>
  );
}

export function OfflineEvaluationIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      //   xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 29 30"
    >
      <defs>
        <path id="a" d="M0 0h12.037v11.619H0z" />
        <path id="c" d="M0 0h11.152v5.787H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#697B8C"
          d="M3.51 19.48c.44.067.897-.337.898-.803a.767.767 0 0 0-.234-.583c-.173-.166-.37-.24-.62-.263-.458-.042-.914.36-.906.827a.776.776 0 0 0 .244.58c.175.165.372.27.618.242zm.9 4.72a.793.793 0 0 0-.264-.625.902.902 0 0 0-.621-.248.881.881 0 0 0-.882.85c-.016.43.453.866.903.858.454-.008.891-.458.864-.835zm-.898-11.913c-.215-.022-.435.094-.604.25a.84.84 0 0 0-.264.568c-.033.472.453.88.87.89.486.01.892-.45.898-.833a.84.84 0 0 0-.264-.625.87.87 0 0 0-.636-.25zm4.416 5.468c-.301-.291-.581-.554-.852-.826a.718.718 0 0 0-.376-.213c-.348-.052-.69-.014-.926.288-.261.334-.291.734.015 1.054.498.52 1.029 1.008 1.553 1.503.09.085.209.183.323.194.32.032.634.029.896-.227.96-.941 1.932-1.871 2.9-2.804a.931.931 0 0 0 .238-.387c.153-.438-.134-.877-.585-1.045-.325-.011-.635-.012-.894.245-.682.676-1.38 1.337-2.07 2.004l-.222.214zm0 5.491c-.286-.276-.54-.537-.813-.778a1.013 1.013 0 0 0-.675-.274c-.172-.003-.296.086-.44.14-.27.098-.343.346-.41.566-.083.278.045.547.238.745.476.488.97.958 1.472 1.42.12.112.289.203.45.24.314.072.605-.047.823-.253.976-.926 1.943-1.86 2.903-2.802a.884.884 0 0 0 .271-.627c.004-.177-.092-.304-.157-.45-.118-.263-.374-.337-.622-.383-.318-.06-.584.092-.804.301-.55.523-1.093 1.053-1.64 1.58l-.596.575zm0-11.04c-.28-.27-.534-.531-.806-.773a1.033 1.033 0 0 0-.702-.28c-.164 0-.277.089-.414.136-.268.093-.35.343-.415.562-.085.287.046.561.25.769.472.478.956.945 1.453 1.4a.918.918 0 0 0 .592.255c.293.01.529-.111.723-.296.773-.735 1.537-1.479 2.304-2.22.187-.18.387-.349.557-.543.154-.176.27-.373.279-.625.006-.168-.081-.29-.134-.43-.098-.258-.358-.323-.581-.409a.616.616 0 0 0-.396.018 1.48 1.48 0 0 0-.534.33c-.711.7-1.433 1.39-2.176 2.106zM4.115 3.912c0 .42-.012.824.003 1.227.014.339.091.666.251.974.156.302.342.577.6.809.276.247.623.374.936.557.264 0 .506.116.773.115 3.177-.003 6.354 0 9.531-.004.529-.001 1.004-.186 1.443-.464.372-.235.644-.552.836-.935a2.75 2.75 0 0 0 .247-.724c.041-.213.04-.42.045-.63.007-.3.002-.602.002-.925h3.252c.28 0 .614.202.738.438.081.155.121.312.12.49-.006 1.944-.003 3.888-.003 5.838l-.866.835-6.99 6.744c-.2.193-.348.42-.473.66-.17.328-.32.664-.48.997-.2.42-.402.84-.6 1.26-.196.412-.387.826-.582 1.24-.165.349-.35.69-.492 1.048a2.693 2.693 0 0 0-.204 1.026c.004.424.117.814.307 1.182.207.4.545.694.924.946.22.147.463.24.716.312.334.096.678.09 1.02.083.135-.093.308-.047.45-.112.132-.06.26-.144.398-.163.165-.023.282-.123.423-.18.39-.161.776-.334 1.16-.508.533-.241 1.07-.471 1.605-.705.245-.107.484-.233.743-.32.246-.082.47-.223.707-.332.187-.086.354-.195.5-.337.566-.549 1.134-1.095 1.72-1.66.005.086.013.155.013.224 0 1.774-.004 3.547.006 5.32.001.236-.12.408-.224.592-.065.114-.444.273-.582.276h-.147c-7 0-14-.001-20.999.006-.242 0-.427-.104-.623-.193-.14-.064-.178-.227-.245-.352-.038-.073-.093-.158-.068-.256.01-.036.002-.075.002-.113C.008 20.406.009 12.614 0 4.82c0-.234.113-.409.195-.604a.298.298 0 0 1 .145-.132c.208-.096.41-.184.659-.18.948.017 1.896.007 2.845.007h.27z"
        />
        <g transform="translate(16.963 10.807)">
          <mask id="b" fill="#fff">
            <use xlinkHref="#a" />
          </mask>
          <path
            fill="#697B8C"
            d="M3.725 11.619L0 8.024l.124-.12C2.75 5.37 5.374 2.835 8.001.303c.067-.065.138-.128.217-.178.364-.226.81-.129 1.103.136.256.232.499.478.747.718.512.494 1.025.985 1.533 1.482.106.103.21.214.288.337.242.379.172.699-.1 1.037-.023.03-.054.053-.082.08l-7.855 7.58-.127.123"
            mask="url(#b)"
          />
        </g>
        <g transform="translate(5.873 .112)">
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill="#697B8C"
            d="M2.349 1.818c0-.322.02-.616-.006-.906C2.32.675 2.458.504 2.54.31c.023-.054.088-.102.146-.13.207-.1.41-.181.659-.179 1.514.013 3.028.01 4.543.002.19-.001.338.074.499.14.167.068.235.203.314.35a.752.752 0 0 1 .103.384c-.005.31-.001.619-.001.942.49 0 .968.012 1.444-.005.244-.008.441.093.609.218a.72.72 0 0 1 .289.556c.011.81.006 1.622.003 2.433 0 .203-.22.52-.41.623a1.18 1.18 0 0 1-.586.142c-3.078-.005-6.155-.006-9.233.002-.242 0-.442-.09-.613-.209a.698.698 0 0 1-.299-.551c-.012-.82-.005-1.641-.005-2.461.083-.232.135-.473.4-.603.188-.093.368-.155.583-.149.448.013.896.004 1.364.004"
            mask="url(#d)"
          />
        </g>
        <path
          fill="#697B8C"
          d="M15.875 20.271l3.321 3.205c-.229.105-.446.224-.678.303-.24.082-.435.257-.697.293-.075.01-.142.075-.216.108-.524.235-1.049.47-1.575.702-.312.137-.623.279-.943.397-.272.1-.54.032-.77-.119-.341-.225-.377-.572-.345-.934.002-.016.02-.03.028-.045.104-.213.211-.425.31-.64.228-.494.46-.986.698-1.476.18-.37.342-.75.524-1.12.093-.188.171-.384.26-.575.014-.032.047-.057.083-.099"
        />
      </g>
    </SvgIcon>
  );
}

export function EneWithCircleIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 35">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#62C3EE"
          d="M17.984 34C8.73 34.064 1.052 26.447 1 17.153.948 7.67 8.473.069 17.978 0 27.283-.067 34.952 7.553 35 16.93c.048 9.461-7.633 17.103-17.016 17.07"
        />
        <g fill="#FFF">
          <path d="M28.992 20.84c0 1.65-.015 3.3.008 4.949.009.65-.424 1.226-1.215 1.21a107.448 107.448 0 0 0-4.086 0c-.724.014-1.217-.472-1.215-1.212.01-3.3.004-6.598.005-9.897 0-.773.423-1.203 1.189-1.205 1.377-.003 2.754-.003 4.131 0 .759.002 1.183.429 1.183 1.185v4.97M14.707 22.261V18.71c.001-.772.42-1.195 1.193-1.197 1.369-.004 2.738-.004 4.107 0 .77.001 1.2.428 1.2 1.195.003 2.368.003 4.736 0 7.104-.001.758-.43 1.18-1.187 1.18-1.376.003-2.753.002-4.13 0-.76 0-1.181-.42-1.182-1.177-.002-1.185 0-2.369 0-3.553M7.58 15.684c4.106-.182 7.992-1.242 11.719-2.932a31.985 31.985 0 0 0 4.63-2.554c.31-.208.315-.263.051-.52-.268-.262-.539-.52-.803-.786-.336-.338-.268-.61.188-.722 1.56-.387 3.12-.768 4.682-1.145.412-.1.634.11.544.526-.317 1.455-.645 2.908-.97 4.361-.034.154-.064.308-.106.46-.108.377-.365.456-.647.187-.342-.325-.67-.665-1.004-.998-.24-.24-.3-.248-.575-.061a36.274 36.274 0 0 1-10.622 4.905c-2.37.665-4.786 1.064-7.252 1.116a4.598 4.598 0 0 1-.627-.027.9.9 0 0 1-.788-.916.901.901 0 0 1 .84-.892c.246-.014.494-.002.74-.002M13.413 23.53c0 .765.002 1.53 0 2.295-.002.734-.423 1.165-1.15 1.166-1.4.003-2.799.004-4.198 0-.705-.001-1.143-.42-1.148-1.126-.01-1.56-.011-3.119 0-4.678.005-.701.454-1.127 1.153-1.128 1.4-.003 2.799-.003 4.198 0 .708.002 1.142.442 1.145 1.156.002.772 0 1.544 0 2.316" />
        </g>
      </g>
    </SvgIcon>
  );
}

export function CompletedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 30">
      <g fill="none" fillRule="evenodd" transform="matrix(1 0 0 -1 0 30)">
        <path d="M0 0h30v30H0z" />
        <circle cx="15" cy="15" r="11.25" fill="#56D747" />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M10.281 13.325l2.685-2.673 6.732 7.141"
        />
      </g>
    </SvgIcon>
  );
}

export function PartiallyCompletedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31">
      <g
        fill="none"
        fillRule="evenodd"
        transform="matrix(1 0 0 -1 .312 30.929)"
      >
        <path d="M0 0h30v30H0z" />
        <circle cx="15.25" cy="15.25" r="11.25" fill="#F3DF6D" />
        <path
          stroke="#917F1A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M10.052 14.277l2.685-2.673 6.732 7.141"
        />
      </g>
    </SvgIcon>
  );
}

export function GridViewIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 27">
      <g fillRule="nonzero" transform="translate(0 1)">
        <rect width="11.818" height="11.818" rx="1.182" />
        <rect width="11.818" height="11.818" x="14.182" rx="1.182" />
        <rect width="11.818" height="11.818" y="14.182" rx="1.182" />
        <rect width="11.818" height="11.818" x="14.182" y="14.182" rx="1.182" />
      </g>
    </SvgIcon>
  );
}

export function ListViewIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 27">
      <g fillRule="evenodd">
        <path d="M29 12.638c-.06-.19-.116-.382-.183-.57-.538-1.522-2.07-2.385-3.69-2.08-1.537.29-2.615 1.678-2.558 3.293.054 1.53 1.299 2.839 2.86 3.008a3.226 3.226 0 0 0 3.458-2.358c.032-.116.075-.23.113-.344v-.95M29 22.464c-.175-.698-.448-1.34-.99-1.85a3.245 3.245 0 0 0-3.91-.425 3.176 3.176 0 0 0-1.4 3.646c.42 1.375 1.751 2.33 3.167 2.272 1.49-.062 2.736-1.085 3.058-2.507.02-.086.05-.17.075-.255v-.88M29 2.88c-.093-.289-.162-.588-.284-.863C28.07.57 26.47-.176 24.922.237c-1.522.405-2.515 1.87-2.342 3.458.165 1.52 1.442 2.697 3.036 2.8 1.539.097 2.954-.965 3.307-2.483.02-.085.051-.168.077-.252v-.88M16.785 6.51c1.357.003 2.416-.527 3.058-1.73 1.1-2.059-.325-4.495-2.703-4.658a3.505 3.505 0 0 0-.24-.009C10.377.113 9.852.11 3.327.115 1.741.116.481 1.075.102 2.535c-.49 1.89.875 3.794 2.837 3.949.283.022.569.024.853.024 3.109.002.217.001 3.326.001 3.222 0 6.445-.003 9.667.002zM3.426 19.717c-1.538.001-2.723.769-3.214 2.067-.775 2.046.661 4.186 2.9 4.321.08.005.16.006.24.006 6.501 0 7.003.003 13.505 0 1.545-.002 2.776-.877 3.212-2.263.607-1.93-.766-3.953-2.797-4.108-.362-.027-.728-.023-1.092-.024H7.127c-3.233 0-.467-.003-3.701 0zM16.933 16.3c1.606-.003 2.882-1.027 3.215-2.553.412-1.89-1.068-3.793-3.02-3.814-2.766-.029-5.534-.01-8.3-.01-3.86-.001-1.721-.008-5.581.002C1.422 9.93 0 11.344.003 13.117c.001 1.758 1.416 3.174 3.219 3.181 3.302.013.604.004 3.907.004 3.268 0 6.536.005 9.804-.002z" />
      </g>
    </SvgIcon>
  );
}

export function GuidedReadingIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 19">
      <path
        // fill={props.color ?? "#A5AAB6"}
        fillRule="nonzero"
        d="M24.1 3.167c.496 0 .9.397.9.884v14.064c0 .27-.123.523-.339.691a.911.911 0 0 1-.763.172c-2.158-.484-5.945-1.045-9.536-.181 2.076-1.931 5.009-2.273 6.787-2.277 1.267-.003 2.297-1.016 2.297-2.259V3.167zm-22.546 0V14.26c0 1.243 1.03 2.256 2.297 2.259 1.778.004 4.71.346 6.787 2.277-3.591-.864-7.378-.303-9.536.18a.91.91 0 0 1-.763-.17.874.874 0 0 1-.339-.692V4.051c0-.487.404-.884.9-.884h.654zM3.569 0c2.127.005 5.995.482 8.008 3.626a.828.828 0 0 1 .125.447v13.871c-2.452-2.488-6.008-2.917-8.13-2.922-.503-.001-.912-.397-.912-.884V.884c0-.237.095-.46.268-.627A.913.913 0 0 1 3.567 0zm17.864 0c.241 0 .468.091.64.257.172.167.267.39.267.627v13.255c0 .486-.409.882-.912.883-2.122.005-5.678.434-8.13 2.922V4.074c0-.165.043-.32.125-.448C15.436.482 19.305.005 21.431 0z"
      />
    </SvgIcon>
  );
}

export function LessonIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 22">
      <path
        // fill={props.color ?? "#A5AAB6"}
        fillRule="evenodd"
        d="M8.488 5.429h3.576c.15 0 .3.004.449-.01.3-.031.522-.288.532-.605.014-.414-.26-.673-.725-.673-2.547-.002-5.095-.001-7.643 0a1.27 1.27 0 0 0-.243.022.608.608 0 0 0-.48.564c-.03.413.237.7.671.7 1.288.004 2.575.002 3.863.002zm7.27 12.432H2.756c-.116 0-.232.004-.347.016-.7.07-1.26.816-1.165 1.548.104.802.648 1.285 1.456 1.286h12.853c.066 0 .132-.007.205-.01v-2.84zM16.511 22H2.285c-.018-.01-.035-.025-.054-.03-1.437-.31-2.23-1.332-2.23-2.876 0-5.4-.002-10.798.002-16.197 0-.242.012-.49.06-.725C.323.862 1.36.002 2.667 0 7.184-.001 11.7 0 16.217 0c.561 0 .78.228.78.817 0 6.787-.002 13.575.003 20.363 0 .398-.124.68-.49.819z"
      />
    </SvgIcon>
  );
}

export function FreeplayIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 30">
      <g
        // fill={props.color ?? "#A5AAB6"}
        fillRule="evenodd"
        transform="translate(1)"
      >
        <path
          fillRule="nonzero"
          d="M19.923 9.275c.474.174.96.248 1.461.222.501-.026.958-.158 1.372-.396.131.379.374.738.728 1.079.354.34.78.603 1.28.786.947.349 1.796.286 2.548-.189.751-.474 1.303-1.202 1.657-2.183.133-.372.239-.851.316-1.438.078-.588.119-1.136.123-1.645l-2.065-.22c.024.43.006.874-.055 1.332-.06.459-.158.873-.292 1.245-.353.981-.91 1.332-1.673 1.051-.421-.155-.713-.398-.877-.728-.164-.33-.155-.748.026-1.252.22-.61.419-1.123.598-1.537l-1.857-.549c-.437 1.131-.846 1.874-1.227 2.23-.382.355-.809.446-1.282.272-.763-.281-.963-.925-.6-1.933.144-.398.41-.931.8-1.599l-1.883-.602c-.478.665-.817 1.276-1.018 1.833-.315.875-.35 1.696-.105 2.462.246.766.92 1.353 2.025 1.76z"
        />
        <g transform="rotate(-24 40.479 -47.464)">
          <rect width="1" height="1.823" x=".151" rx=".366" />
          <rect width="1" height="1.823" x=".292" y="2.714" rx=".366" />
          <rect width="1" height="1.823" x=".146" y="5.984" rx=".366" />
          <rect width="1" height="1.823" y="9.253" rx=".366" />
        </g>
        <ellipse cx="18.485" cy="23.584" rx="6.346" ry="6.416" />
        <path d="M7.454 2.743L19.52 12.811 4.612 18.297z" />
      </g>
    </SvgIcon>
  );
}

export function AddIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path
        fill="#62C3EE"
        fillRule="evenodd"
        d="M4.798 9.197v.366c0 1.025-.004 2.05.001 3.075.005.883.477 1.35 1.363 1.356.537.003 1.074.001 1.61 0 .96-.002 1.424-.461 1.426-1.415V9.534c0-.104.01-.208.016-.337h.341c1.035 0 2.07.004 3.104-.001.845-.005 1.323-.482 1.332-1.327.006-.566.003-1.132 0-1.698-.004-.91-.462-1.37-1.368-1.371-1.025-.003-2.05 0-3.075-.001h-.35v-.35c0-1.034.004-2.069-.001-3.103C9.192.476 8.72.006 7.857.002 7.301-.001 6.744 0 6.188.002c-.927.001-1.386.455-1.39 1.38-.002 1.024 0 2.05 0 3.074V4.8h-.355c-1.035 0-2.07-.003-3.104.001-.869.004-1.33.47-1.335 1.343C0 6.729-.003 7.314.004 7.9c.011.808.49 1.288 1.303 1.295.937.008 1.874.002 2.811.002h.68"
      />
    </SvgIcon>
  );
}

export function EyeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 16">
      <g fill="#62C3EE" fillRule="evenodd">
        <path d="M10.4.126c3.58.029 6.369 1.633 8.538 4.382.65.823 1.144 1.77 1.696 2.668.185.3.189.629.028.952-1.422 2.85-3.404 5.183-6.437 6.347-4.04 1.552-7.724.787-10.96-2.07C1.94 11.235.931 9.816.15 8.233c-.168-.34-.216-.669-.04-1.022C1.548 4.337 3.587 2.074 6.618.83 7.826.334 9.093.114 10.4.126zm-.02 3.78A3.76 3.76 0 0 0 6.61 7.68a3.76 3.76 0 0 0 3.775 3.77c2.114-.007 3.78-1.691 3.77-3.812a3.76 3.76 0 0 0-3.775-3.733z" />
        <path d="M10.399 5.626A1.993 1.993 0 0 0 8.4 7.627c0 1.11.895 2.003 2.001 1.999A1.993 1.993 0 0 0 12.4 7.605a1.994 1.994 0 0 0-2.001-1.98" />
      </g>
    </SvgIcon>
  );
}

export function EneIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 21">
      <g fill="#62C3EE" fillRule="evenodd">
        <path d="M23.992 13.966c0 1.65-.015 3.3.008 4.948.009.652-.424 1.227-1.215 1.212a107.448 107.448 0 0 0-4.086 0c-.724.013-1.217-.474-1.215-1.214.01-3.298.004-6.597.005-9.896 0-.773.423-1.204 1.189-1.205 1.377-.003 2.754-.003 4.131 0 .759.002 1.183.429 1.183 1.184v4.971M9.707 15.387v-3.552c.001-.772.42-1.196 1.193-1.198 1.369-.003 2.738-.003 4.107 0 .77.002 1.2.429 1.2 1.196.003 2.368.003 4.736 0 7.104-.001.758-.43 1.18-1.187 1.18-1.376.002-2.753.002-4.13 0-.76 0-1.181-.42-1.182-1.178-.002-1.184 0-2.368 0-3.552M2.58 8.81c4.106-.183 7.992-1.243 11.719-2.932a31.985 31.985 0 0 0 4.63-2.554c.31-.208.315-.263.051-.521-.268-.262-.539-.52-.803-.786-.336-.337-.268-.608.188-.722C19.925.91 21.485.527 23.047.15c.412-.1.634.11.544.526-.317 1.456-.645 2.909-.97 4.362-.034.154-.064.308-.106.46-.108.377-.365.456-.647.187-.342-.325-.67-.665-1.004-.998-.24-.24-.3-.248-.575-.061A36.274 36.274 0 0 1 9.667 9.53c-2.37.665-4.786 1.064-7.252 1.115a4.598 4.598 0 0 1-.627-.026A.9.9 0 0 1 1 9.704a.901.901 0 0 1 .84-.892c.246-.014.494-.002.74-.002M8.413 16.657c0 .764.002 1.529 0 2.294-.002.734-.423 1.165-1.15 1.166-1.4.003-2.799.003-4.198 0-.705-.002-1.143-.42-1.148-1.126-.01-1.56-.011-3.119 0-4.678.005-.701.454-1.127 1.153-1.128 1.4-.003 2.799-.004 4.198 0 .708.001 1.142.442 1.145 1.155.002.772 0 1.545 0 2.317" />
      </g>
    </SvgIcon>
  );
}

export function RemoveIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 6">
      <path
        fill="#FFF"
        fillRule="evenodd"
        d="M12.66 5.321c.844-.004 1.322-.481 1.33-1.326.007-.566.004-1.133.001-1.699-.004-.908-.462-1.368-1.368-1.37-1.025-.003-10.25-.004-11.284 0C.47.929.009 1.396.004 2.269 0 2.854-.003 3.44.004 4.026c.011.808.49 1.288 1.303 1.295"
      />
    </SvgIcon>
  );
}

export function InfoIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h20v20H0z" />
        <circle cx="10" cy="10" r="7.5" fill="#FF8E42" />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
          d="M10 6.667V10M10 13.333h.008"
        />
      </g>
    </SvgIcon>
  );
}
